
import { CompanyRequest } from "@/lib/types";
import RequestStatusBadge from "./RequestStatusBadge";

interface ProcessedRequestsTableProps {
  processedRequests: CompanyRequest[];
}

const ProcessedRequestsTable = ({ processedRequests }: ProcessedRequestsTableProps) => (
  <div className="bg-white rounded-lg shadow-sm border p-6">
    <h2 className="text-xl font-medium mb-4">Processed Requests</h2>
    <div className="overflow-x-auto">
      <table className="w-full border-collapse">
        <thead>
          <tr className="border-b">
            <th className="text-left py-3 px-4 font-medium">Company Name</th>
            <th className="text-left py-3 px-4 font-medium">Location</th>
            <th className="text-left py-3 px-4 font-medium">Status</th>
            <th className="text-left py-3 px-4 font-medium">Date Processed</th>
          </tr>
        </thead>
        <tbody>
          {processedRequests.map((request) => (
            <tr key={request.id} className="border-b hover:bg-gray-50">
              <td className="py-3 px-4">
                <span>{request.companyName}</span>
              </td>
              <td className="py-3 px-4">
                {request.location}
              </td>
              <td className="py-3 px-4">
                <RequestStatusBadge status={request.status} />
              </td>
              <td className="py-3 px-4">
                {new Date(request.createdAt).toLocaleDateString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default ProcessedRequestsTable;
